import { render, staticRenderFns } from "./form5_1b.vue?vue&type=template&id=3cf10492&scoped=true"
import script from "./form5_1b.vue?vue&type=script&lang=js"
export * from "./form5_1b.vue?vue&type=script&lang=js"
import style0 from "./form5_1b.vue?vue&type=style&index=0&id=3cf10492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf10492",
  null
  
)

export default component.exports